// extracted by mini-css-extract-plugin
module.exports = {"divider":"top-nav-items_divider__VVpS8","space":"top-nav-items_space__H5jum","link":"top-nav-items_link__YZ4rI","active":"top-nav-items_active__uF7_5"};